export default __webpack_public_path__ + "static/media/3.62b63d87.png";